import React, { useState } from "react";
import { Flex, Modal, Button } from "antd";
import PartyIcon from "./PartyIcon";
import AccountStatusCard from "./AccountStatusCard";
import { validPartyTypeForExperience } from "../common/helper";

const selectedTabStyle = { backgroundColor: "#fa5705", color: "white" };

const ParticipantsControlModal = ({
  guestModalVisible,
  setGuestModalVisible,
  handleGuestModalOk,
  handleGuestChange,
  guests,
  isShared,
  handleTabChange,
  maxParticipants = undefined,
  experienceType = "Shared and Private",
}) => {
  const [errorMessageTooltipVisible, setErrorMessageTooltipVisible] =
    useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const tabClicked = (intendedPartyType) => {
    const res = validPartyTypeForExperience(
      intendedPartyType,
      experienceType || "Shared and Private"
    );

    if (res.valid) {
      handleTabChange(intendedPartyType);
      setErrorMessageTooltipVisible(false);
    } else {
      setErrorMessageTooltipVisible(true);
      setErrorMessage(res.errors[0]);
    }
  };

  const handleGuestChangeButtonPressed = (type, operation) => {
    if(operation === "decrement" && (guests.adults + guests.children + guests.elderly) === 1){
      return      
    }

    handleGuestChange(type, operation);
  }

  return (
    <Modal
      title="Select Guests"
      open={guestModalVisible}
      onCancel={() => setGuestModalVisible(false)}
      onOk={handleGuestModalOk}
      okButtonProps={{ style: { backgroundColor: "green" } }}
    >
      <Flex justify="center" vertical>
        {errorMessageTooltipVisible && (
          <AccountStatusCard message={errorMessage} />
        )}
        {["adults", "children", "elderly"].map((type) => (
          <Flex
            justify="space-between"
            key={type}
            style={{
              marginBottom: 10,
            }}
          >
            <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
            <div>
              <Button onClick={() => handleGuestChangeButtonPressed(type, "decrement")}>
                -
              </Button>
              <span style={{ margin: "0 10px" }}>{guests[type]}</span>
              <Button
                onClick={() => {
                  if (
                    !maxParticipants ||
                    guests.adults + guests.children + guests.elderly <
                      maxParticipants
                  )
                  handleGuestChangeButtonPressed(type, "increment");
                }}
              >
                +
              </Button>
            </div>
          </Flex>
        ))}
        <Button.Group>
          <Button
            type={!isShared ? "primary" : "default"}
            onClick={() => tabClicked("private")}
            size="large"
            style={{ ...(!isShared && selectedTabStyle), width: "50%" }}
            icon={<PartyIcon partyType={"private"} />}
          >
            Private
          </Button>
          <Button
            onClick={() => tabClicked("shared")}
            size="large"
            style={{ ...(isShared && selectedTabStyle), width: "50%" }}
            icon={<PartyIcon partyType={"shared"} />}
          >
            Shared
          </Button>
        </Button.Group>
      </Flex>
    </Modal>
  );
};

export default ParticipantsControlModal;
